import React from "react";

const BASE_WIDTH = 280;
const BASE_HEIGHT = 138;

interface OwnProps {
  width?: number;
  height?: number;
  color?: string;
}
export default function EmptyJobsIcon(props: OwnProps) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M139.961 134.366C215.752 134.366 277.193 124.269 277.193 111.814C277.193 99.3587 215.752 89.2617 139.961 89.2617C64.1701 89.2617 2.72949 99.3587 2.72949 111.814C2.72949 124.269 64.1701 134.366 139.961 134.366Z"
        fill="#E5F4FF"
      />
      <path
        d="M245.165 111.814C245.165 120.27 226.109 125.35 134.777 125.35C51.5011 125.35 31.0195 120.27 31.0195 111.814C31.0195 103.358 74.338 96.5037 134.777 96.5037C195.215 96.5037 245.165 103.358 245.165 111.814Z"
        fill="#CFEAFD"
      />
      <path
        d="M54.3896 109.207C54.3896 104.473 61.3328 85.537 130.764 85.537C214.082 85.537 234.911 104.473 234.911 109.207C234.911 113.941 234.911 118.675 137.707 118.675C54.3896 118.675 54.3896 113.941 54.3896 109.207Z"
        fill="#B5D7F1"
      />
      <path
        d="M41.4765 44.575C53.0124 44.575 62.3641 35.2259 62.3641 23.6932C62.3641 12.1605 53.0124 2.8114 41.4765 2.8114C29.9406 2.8114 20.5889 12.1605 20.5889 23.6932C20.5889 35.2259 29.9406 44.575 41.4765 44.575Z"
        fill="#CFEAFD"
      />
      <path
        d="M41.4757 40.399C50.7044 40.399 58.1858 32.9198 58.1858 23.6936C58.1858 14.4674 50.7044 6.98816 41.4757 6.98816C32.247 6.98816 24.7656 14.4674 24.7656 23.6936C24.7656 32.9198 32.247 40.399 41.4757 40.399Z"
        fill="#B5D7F1"
      />
      <path
        d="M216.811 57.5595C216.513 53.108 215.844 48.6893 214.809 44.3493C213.84 40.2386 212.562 36.2069 210.985 32.2887C209.545 28.7408 208.41 26.7129 208.41 26.7129L198.543 27.9846C198.543 27.9846 199.681 30.3601 200.915 35.0155C201.416 36.906 201.928 39.1783 202.39 41.8288C203.038 45.554 203.475 49.3129 203.7 53.0874C203.792 54.5004 203.857 55.9746 203.903 57.5099C203.918 58.0674 203.945 58.6059 203.952 59.1788C203.979 60.9699 203.853 62.7916 203.631 64.6095C203.429 66.2479 203.135 67.8786 202.78 69.4941C202.277 71.7751 201.667 74.0309 200.95 76.2538C200.381 78.0106 199.773 79.6948 199.162 81.2797C198.318 83.4506 197.418 85.599 196.461 87.7225C195.093 90.7701 194.085 92.8019 194.085 93.2258C194.085 94.5663 195.04 97.0716 201.725 98.7405C212.177 101.353 213.186 97.0449 213.186 97.0449C213.186 97.0449 213.85 95.0284 214.622 91.0604C215.004 89.1012 215.409 86.6799 215.779 83.7469C216.001 81.9939 216.207 80.0653 216.383 77.9686C216.757 73.5506 216.957 69.1196 216.983 64.6859C216.99 64.0137 217.006 63.3645 217.006 62.6732C217.006 60.9203 216.926 59.2246 216.811 57.5595Z"
        fill="#73D2E6"
      />
      <path
        d="M245.844 13.5514C245.722 13.391 233.612 -2.80564 217.908 4.29783C210.852 7.48675 206.302 12.6998 204.656 19.4328C201.584 15.1363 196.916 12.4095 190.735 11.3096C173.846 8.30021 163.643 27.0557 163.543 27.2428C163.47 27.3756 163.444 27.5297 163.47 27.6793C163.496 27.8289 163.573 27.9651 163.687 28.0651C163.801 28.1651 163.946 28.223 164.098 28.229C164.25 28.235 164.399 28.1889 164.521 28.0983C164.598 28.041 172.303 22.6485 185.135 24.9361C192.648 26.2539 200.119 27.804 207.536 29.5839C207.653 29.6125 207.775 29.6095 207.891 29.5753C208.006 29.5411 208.111 29.4768 208.193 29.3891C208.277 29.2974 216.991 19.9369 225.002 16.3164C236.859 10.9545 244.946 14.5138 245.019 14.552C245.154 14.6125 245.304 14.6271 245.448 14.5936C245.591 14.5601 245.72 14.4804 245.814 14.3666C245.907 14.2529 245.961 14.1115 245.967 13.9642C245.972 13.8169 245.929 13.6719 245.844 13.5514Z"
        fill="#7DDDF2"
      />
      <path
        d="M232.779 22.9371C220.806 16.6166 211.501 19.7635 205.721 23.6016C198.795 22.2611 185.852 22.2382 174.885 36.2962C161.419 53.5508 173.231 75.0674 173.349 75.2851C173.467 75.4989 173.693 75.625 173.933 75.625L174.014 75.6212C174.145 75.6045 174.269 75.5492 174.369 75.4621C174.469 75.3751 174.541 75.2603 174.575 75.1323C174.617 74.9834 178.766 59.9821 189.256 47.3677C194.99 40.4743 201.836 34.1003 206.653 29.9031C211.504 30.7089 218.633 32.4924 225.635 36.4032C239.284 44.0336 245.546 56.9459 245.607 57.0758C245.729 57.3278 245.993 57.5035 246.283 57.4539C246.421 57.4397 246.55 57.3826 246.654 57.2908C246.757 57.199 246.829 57.077 246.86 56.9421C246.913 56.7015 252.177 33.1799 232.779 22.9371Z"
        fill="#90DEEF"
      />
      <path
        d="M60.8007 17.8399C61.1214 17.7992 61.3647 17.5899 61.4154 17.3284C62.2323 13.1186 65.7144 9.42181 70.8385 7.97248L70.8442 7.97089C71.0698 7.90717 71.2507 7.75676 71.3154 7.56345C71.4343 7.20824 71.179 6.86914 70.7874 6.789C69.1562 6.45503 67.3977 6.49232 65.6886 6.97574C62.4809 7.88301 60.2543 10.133 59.592 12.7368C59.5483 12.9087 59.4341 13.0661 59.2568 13.1583C58.9765 13.3041 58.6282 13.2737 58.3905 13.0992C56.0029 11.3456 52.6091 10.6752 49.3915 11.5853C47.6907 12.0664 46.266 12.9249 45.204 14.0136C45.0119 14.2105 44.967 14.4884 45.1117 14.7125C45.2828 14.9776 45.6514 15.0968 45.9833 15.0026C45.9862 15.0018 45.9891 15.001 45.9921 15.0002C51.1083 13.5531 56.5164 14.7269 60.172 17.6615C60.3403 17.7967 60.571 17.8689 60.8007 17.8399Z"
        fill="#91BCDD"
      />
      <path
        d="M91.8349 13.6141C90.5511 13.3035 89.1441 13.2639 87.7509 13.5576C85.1277 14.1107 83.2152 15.7056 82.5415 17.6231C82.4863 17.7801 82.3294 17.9025 82.129 17.9447C81.9286 17.9869 81.7151 17.9424 81.5672 17.8281C79.7611 16.4338 77.0887 15.8057 74.4657 16.3588C73.0725 16.6525 71.88 17.2402 70.9669 18.014C70.7904 18.1636 70.7612 18.3869 70.8954 18.5616C71.0295 18.7362 71.2948 18.8205 71.5457 18.7675C71.5481 18.767 71.5505 18.7665 71.5529 18.766C75.73 17.8853 79.9893 18.9692 82.7397 21.2972C82.8872 21.422 83.1106 21.4726 83.3202 21.4285C83.5297 21.3844 83.6913 21.2529 83.7393 21.0868C84.6348 17.9899 87.6301 15.3762 91.8074 14.4954C91.8098 14.4949 91.8121 14.4944 91.8145 14.4939C92.0657 14.4412 92.2418 14.2642 92.2466 14.0601C92.2513 13.8559 92.0833 13.6742 91.8349 13.6141Z"
        fill="#91BCDD"
      />
      <ellipse
        cx="99.9869"
        cy="59.198"
        rx="3.38924"
        ry="1.57596"
        fill="#06C5EF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.376 59.1973H96.5977C96.5978 58.327 98.1152 57.6215 99.9869 57.6215C101.859 57.6215 103.376 58.327 103.376 59.1973Z"
        fill="#47DDFE"
      />
      <rect
        x="100.07"
        y="50.8634"
        width="10.0889"
        height="22.221"
        rx="5.04446"
        fill="#E5F7FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.688 78.4659C104.276 78.4659 103.943 78.7995 103.943 79.2109V85.7498H103.28C102.915 85.7498 102.618 86.0463 102.618 86.412C102.618 86.7777 102.915 87.0742 103.28 87.0742H104.77C105.136 87.0742 105.432 86.7777 105.432 86.412C105.432 86.3994 105.432 86.3868 105.431 86.3743C105.432 86.3594 105.433 86.3443 105.433 86.3291V79.2109C105.433 78.7995 105.099 78.4659 104.688 78.4659Z"
        fill="#0ED4FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.6 78.4661C108.188 78.4661 107.855 78.7996 107.855 79.211V85.75H107.192C106.827 85.75 106.53 86.0464 106.53 86.4121C106.53 86.7778 106.827 87.0743 107.192 87.0743H108.682C109.048 87.0743 109.344 86.7778 109.344 86.4121C109.344 86.3995 109.344 86.3869 109.343 86.3745C109.344 86.3595 109.345 86.3444 109.345 86.3293V79.211C109.345 78.7996 109.011 78.4661 108.6 78.4661Z"
        fill="#0ED4FF"
      />
      <path
        d="M99.205 68.0264C100.157 66.4146 100.334 63.8749 100.304 62.8065V59.9676C100.304 56.0299 100.029 55.2057 100.853 53.6489C101.513 52.4034 102.838 51.6037 103.418 51.3596C104.15 50.9933 106.11 50.5537 108.088 51.7259C110.066 52.898 110.499 55.3278 110.469 56.3962V59.5098C110.469 62.2205 111.812 64.1802 112.484 64.8212C114.608 66.9458 115.078 70.2852 115.048 71.6894C115.048 78.5759 116.452 82.1291 117.154 83.0448C116.299 83.1364 113.381 83.2646 108.546 83.0448C103.711 82.825 100.304 77.5808 99.205 74.9861C98.1793 71.7627 98.7776 69.0032 99.205 68.0264Z"
        fill="#E5F7FF"
      />
      <path
        d="M107.263 52.0925C107.979 51.8536 107.948 51.2567 107.719 51.015H103.273C102.867 51.1767 102.977 51.9146 103.6 52.0925C104.241 52.2756 104.791 52.2756 105.523 52.2756H105.523C106.255 52.2756 106.714 52.2756 107.263 52.0925Z"
        fill="#3CACEB"
      />
      <path
        d="M103.132 50.1905C103.432 50.2883 104.107 50.4552 105.225 50.4552C106.344 50.4552 107.019 50.2883 107.318 50.1905C107.409 50.1609 107.502 50.2283 107.502 50.3236L107.502 50.9346C107.219 51.0722 106.855 51.1671 106.502 51.2323C105.658 51.388 104.792 51.388 103.949 51.2323C103.596 51.1671 103.232 51.0722 102.949 50.9346L102.949 50.3236C102.949 50.2283 103.042 50.1609 103.132 50.1905Z"
        fill="#6BC3F4"
      />
      <path
        d="M106.283 47.5472C105.592 47.341 104.856 47.341 104.166 47.5472C102.728 47.9763 100.593 49.5201 102.947 50.5206C103.654 50.8022 105.553 51.1965 107.501 50.5206C109.855 49.5201 107.72 47.9764 106.283 47.5472Z"
        fill="#E5F7FF"
      />
      <path
        d="M111.677 79.0922L118.454 82.0912L118.454 82.0927C116.308 83.4095 115.394 83.9379 113.466 83.4055C111.538 82.8732 111.126 82.5469 110.374 82.0371C109.621 81.5272 109.202 80.7309 109.562 79.9181L109.563 79.9166C109.923 79.1038 110.87 78.7347 111.677 79.0922Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M106.806 62.4405C109.071 62.4481 111.629 63.7225 112.209 64.4551C114.682 66.9276 115.109 69.9802 115.048 71.0486C115.048 77.349 116.025 80.8472 116.513 81.8546C111.678 81.8546 108.76 79.5957 107.905 78.4663C99.4801 68.6493 100.533 62.4194 106.806 62.4405Z"
        fill="#64BDEF"
      />
      <path
        d="M111.672 78.5392L117.429 83.2061L117.428 83.2073C115.012 83.917 113.991 84.188 112.27 83.1701C110.549 82.1522 110.237 81.7295 109.643 81.0405C109.05 80.3515 108.855 79.4736 109.415 78.7832L109.416 78.7819C109.976 78.0915 110.986 77.9828 111.672 78.5392Z"
        fill="#E5F7FF"
      />
      <path
        d="M110.254 78.7335L115.146 84.2991L115.145 84.3002C112.644 84.5949 111.593 84.691 110.067 83.399C108.54 82.107 108.304 81.638 107.834 80.8594C107.365 80.0807 107.32 79.1824 107.987 78.5957L107.989 78.5946C108.656 78.0077 109.671 78.07 110.254 78.7335Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M105.524 62.5322C108.179 62.3492 109.741 64.4552 110.102 65.0047C112.208 68.2083 110.713 71.3555 110.652 72.4239C110.652 78.7243 113.569 81.5832 114.058 82.5905C107.447 83.7794 105.783 82.5905 103.692 81.0337C95.4502 74.8966 98.1059 63.0435 105.524 62.5322Z"
        fill="#64BDEF"
      />
      <path
        d="M111.508 89.6933C111.716 89.6419 111.951 89.6016 112.213 89.5738L109.265 87.8825H108.603C108.237 87.8825 107.625 87.7015 107.236 87.4783C106.847 87.2551 106.828 87.0741 107.193 87.0741H108.683C109.049 87.0741 109.661 87.2551 110.05 87.4783C110.064 87.4865 110.078 87.4947 110.092 87.5028C110.107 87.5114 110.123 87.5201 110.138 87.5288L113.597 89.5128C113.72 89.5097 113.843 89.5067 113.964 89.5039C113.969 89.407 113.982 89.3014 114.005 89.1848C114.156 88.3941 115.312 88.4529 118.134 88.6333L118.136 88.6339L118.223 88.9217C119.016 88.9535 120.097 89.0982 121.588 89.302L121.591 89.3027L121.541 89.4821C122.191 89.619 122.936 89.7871 123.805 89.9841L123.807 89.985L122.519 90.6431C123.004 91.0527 123.672 91.5666 124.562 92.1909C126.16 93.2942 128.586 94.8401 132.1 96.8561C133.298 97.5082 136.119 99.3714 136.278 100.881C136.299 100.929 136.304 100.98 136.294 101.034C136.61 101.604 137.558 102.613 139.799 103.899L143.112 105.799C143.548 106.043 144.12 106.401 144.629 106.793C144.74 106.878 144.844 106.961 144.939 107.043C145.635 107.634 146.102 108.258 145.701 108.65C145.67 108.68 145.636 108.709 145.6 108.736C145.871 108.856 146.039 108.979 146.081 109.059L146.513 109.307C149.939 109.92 149.446 110.864 148.463 111.127C147.991 111.253 147.253 111.253 146.341 111.127C144.442 110.864 140.655 109.919 141.947 109.307L141.948 109.307L141.511 109.056C141.266 108.994 141.02 108.88 140.861 108.764C140.643 108.718 140.392 108.662 140.117 108.597C139.914 108.549 139.71 108.498 139.504 108.444C138.573 108.204 137.47 107.878 136.42 107.476C134.515 106.747 133.718 106.281 131.553 105.015L131.46 104.961C131.442 104.961 131.423 104.961 131.404 104.961C129.532 104.961 127.264 104.531 126.331 104L126.324 103.996C125.395 103.463 126.164 103.032 128.04 103.032C128.068 103.032 128.095 103.032 128.123 103.032L125.601 101.585C124.778 101.124 123.523 100.461 122.139 99.8196C118.727 98.5501 115.405 96.8892 113.099 95.2345C112.74 94.9803 112.393 94.719 112.068 94.4524C112.025 94.4114 111.981 94.3694 111.938 94.3263C110.423 93.0209 109.661 91.7656 110.12 90.7612C110.122 90.7582 110.123 90.7553 110.124 90.7523C110.135 90.7149 110.148 90.6781 110.162 90.6418L105.352 87.8825H104.69C104.324 87.8825 103.712 87.7015 103.323 87.4783C102.934 87.2551 102.915 87.0741 103.28 87.0741H104.77C105.136 87.0741 105.748 87.2551 106.137 87.4783C106.151 87.4865 106.165 87.4947 106.178 87.5028C106.194 87.5114 106.21 87.5201 106.225 87.5288L110.627 90.0537C110.821 89.9084 111.095 89.7851 111.508 89.6933Z"
        fill="#393939"
        fillOpacity="0.25"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-2.64151"
          y="-1.98113"
          width="285.283"
          height="142.642"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="0.660377" />
          <feGaussianBlur stdDeviation="1.32075" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="109.547"
          y1="80.0033"
          x2="119.043"
          y2="82.0042"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBF9FF" />
          <stop offset="1" stopColor="#F4FCFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="107.938"
          y1="78.6666"
          x2="115.716"
          y2="84.468"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBF9FF" />
          <stop offset="1" stopColor="#F4FCFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
